// export const getInitialRole = () => {
//   if (typeof document === "undefined") return null;

//   const role = document.cookie
//     .split("; ")
//     .find((row) => row.startsWith("userRole="))
//     ?.split("=")[1];
//   console.log("getInitialRole", role);

//   return role === "student" || role === "teacher" ? role : null;
// };
export const getInitialRole = () => {
  if (typeof window === "undefined") return null;

  const role = localStorage.getItem("userRole");
  // console.log("getInitialRole", role);

  return role === "student" || role === "teacher" ? role : null;
};
